export default __webpack_public_path__ + "static/media/Litto-1Closed.0f0c8766.jpg";